import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coupons: [],
  isLoading: false,
};

const couponSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    setCoupons(state, action) {
      state.coupons = action.payload;
      state.isLoading = false;
    },

    addCoupon(state, action) {
      state.coupons.push(action.payload);
    },

    removeCoupon(state, action) {
      state.coupons = state.coupons.filter(
        (c) => c._id !== action.payload
      );
    },

    setCouponLoading(state) {
      state.isLoading = true;
    },
  },
});

export const {
  setCoupons,
  addCoupon,
  removeCoupon,
  setCouponLoading,
} = couponSlice.actions;

export default couponSlice.reducer;